:<template>
  <!-- 新武器 -->
  <section class="xwq" id="xwq"><h2>{{xwqData.text}}</h2><p v-html="getInt(xwqData.int)"></p><img :src="'https://cdn1.zygames.com/qqsm/t1/weapon/'+xwqData.id+'.png'" alt="" /><a href="https://qqsm.zygames.com/info/weapon.html" class="wqlb" target="_blank"><img src="https://cdn1.zygames.com/qqsm/Public/img/version/wqlb.png" alt=""></a></section>
  <!-- <section class="xwq" id="xwq"><a href="https://qqsm.zygames.com/info/weapon.html" class="wqlb" target="_blank"><img src="https://cdn1.zygames.com/qqsm/Public/img/version/wqlb.png" alt=""></a></section> -->
      <!-- 新武器带轮播 -->
    <!-- <section class="xwq" id="xwq"><div class="inner"><xwq-tab-play></xwq-tab-play></div></section> -->
    <!-- <section class="xwq" id="xwq"><h2></h2><xwq-tab-play></xwq-tab-play></section> -->
</template>

<script>
import { mapGetters } from "vuex";
// import xwqTabPlay from "../components/xwqTabPlay.vue";
export default {
  name: "xwqTab",
  props: ['xwqData'],
  data() {
    // console.log(this.xwqData);
    return {
    };
  },
  methods: {
    getInt(ints) {
      return ints.replace(/\r\n|\n|\r|“/g, '<h6 style="color:#f00;">“').replace(/\r\n|\n|\r|”/g, "”</h6>");
      // return ints.replace(/\r\n|\n|\r|“/g, "<strong style='color:#069;'>“").replace(/\r\n|\n|\r|”/g,"”</strong>");
    }
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
.xwq {
  // background: url("../../assets/img/xwq.jpg") no-repeat top center;
  background: url("https://cdn1.zygames.com/qqsm/Public/img/version/bg6.jpg") no-repeat top center;
  // height: 930px;
  height: 885px;
  position: relative;
  min-width: 1200px;
  box-sizing: border-box;
  padding-top: 50px;

  h2 {
    background: url("https://cdn1.zygames.com/qqsm/Public/img/version/title_xwq.png") no-repeat top center;
    width: 941px;
    height: 165px;
    margin: 0px auto;
    color: #c00;
    font-weight: bold;
    font-size: 42px;
    line-height: 290px;
    font-family: "微软雅黑", "Microsoft Yahei";
  }

  p {
    width: 720px;
    margin: 20px auto 20px;
    font-size: 15px;
    color: #333;
    text-align: center;
    line-height: 2;
    strong, h6 {
      display: block;
      font-weight: bold;
      color: red;
    }
  }

  img {
    max-width: 1200px;
    max-height: 480px;
    -webkit-filter: drop-shadow(-30px -20px 6px rgba(0, 0, 0, 0.4));
    filter: drop-shadow(-30px -20px 6px rgba(0, 0, 0, 0.4));
    // filter:drop-shadow(-30px -20px 5px #ccc);
  }

  .wqlb {
    position: absolute;
    bottom: 60px;
    left: 50%;
    margin-left: -183px;
    filter: alpha(opacity=75);
    -moz-opacity: 0.75;
    opacity: 0.75;

    img {
      width: 365px;
      height: 67px;
      background-color: rgba(255, 255, 255, 0.5);
      -webkit-filter: drop-shadow(0 0 0 transparent);
      filter: drop-shadow(0 0 0 transparent);
    }

    &:hover {
      filter: alpha(opacity=100);
      -moz-opacity: 1;
      opacity: 1;

      img {
        box-shadow: 0 0 10px 1px #f66;
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/newItem/xwq.vue